import { render } from "./AppManagement.vue?vue&type=template&id=4b90384f"
import script from "./AppManagement.vue?vue&type=script&lang=js"
export * from "./AppManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__